require("!!/home/hellomojito/agency-space/node_modules/script-loader/addScript.js")(require("!!/home/hellomojito/agency-space/node_modules/raw-loader/index.js!/home/hellomojito/agency-space/assets/plugins/modernizr.custom.js"))


//////////////////
// WEBPACK FOOTER
// ./assets/plugins/modernizr.custom.js
// module id = 715
// module chunks = 0